var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment_result"},[(_vm.result.status === 'success')?_c('SuccessForm',{attrs:{"resultProps":_vm.result}}):_c('FailedForm',{attrs:{"resultProps":_vm.result}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }